<script>
  import ShippingAddressResult from "./elements/shipping-address-result.svelte"
</script>

<div class="est-shipping-container">
  <!-- <div class="est-shipping-title">Estimate Shipping</div> -->
  <ShippingAddressResult />
</div>

<style>
  .est-shipping-container {
    padding: 2rem 1.5rem 2rem 1.5rem;
  }

  /* .est-shipping-title {
		font-size: medium;
		font-weight: 500;
		margin-bottom: 1rem;
	} */
</style>
